(function (root, factory) {
  'use strict';
  var exported = factory();
  if (typeof module === 'object' && module.exports) module.exports = exported;
  root.FBGroupGiftsCatalogue = exported;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  function query(input) {
    input = input || {};
    var value = {
      q: String(input.q || '').trim(),
      category: ['all', 'flowers', 'gifts', 'cards'].includes(input.category) ? input.category : 'all',
      sort: ['recommended', 'price_asc', 'price_desc'].includes(input.sort) ? input.sort : 'recommended'
    };
    ['minPriceCents', 'maxPriceCents'].forEach(function (key) {
      if (Number.isSafeInteger(input[key]) && input[key] >= 0) value[key] = input[key];
    });
    return value;
  }
  function create(options) {
    var generation = 0, disposed = false;
    var state = { query: query(), products: [], total: 0, nextOffset: null, revision: null, loading: false, error: null, needsRefresh: false, loadedPages: 0 };
    function changed() { if (options.onChange && !disposed) options.onChange(state); }
    async function load(append) {
      if (disposed || (append && (state.loading || state.nextOffset === null || state.needsRefresh))) return;
      var current = ++generation;
      var criteria = Object.assign({}, state.query, { offset: append ? state.nextOffset : 0 });
      if (append) criteria.catalogueRevision = state.revision;
      state.loading = true; state.error = null; changed();
      try {
        var result = await options.request(criteria);
        if (disposed || current !== generation) return;
        var products = append ? state.products.slice() : [];
        var handles = new Set(products.map(function (p) { return p.handle; }));
        (result.page.products || []).forEach(function (p) {
          if (!handles.has(p.handle)) { products.push(p); handles.add(p.handle); }
        });
        state.products = products;
        state.total = result.page.total;
        state.nextOffset = result.page.hasMore ? result.page.nextOffset : null;
        state.revision = result.catalogueRevision;
        state.loadedPages = append ? state.loadedPages + 1 : 1;
        state.needsRefresh = false;
      } catch (error) {
        if (disposed || current !== generation) return;
        state.error = error;
        state.needsRefresh = error.code === 'EDIT_CONFLICT';
      } finally {
        if (!disposed && current === generation) { state.loading = false; changed(); }
      }
    }
    return {
      state: state,
      search: function (input) {
        state.query = query(input);
        state.nextOffset = null; state.revision = null;
        return load(false);
      },
      refresh: function () { return load(false); },
      more: function () { return load(true); },
      restore: async function (saved) {
        saved = saved || {};
        var pages = Number.isSafeInteger(saved.loadedPages) && saved.loadedPages > 0 ? saved.loadedPages : 1;
        state.query = query(saved.query);
        state.nextOffset = null; state.revision = null;
        var expected = generation + 1;
        await load(false);
        while (!disposed && generation === expected && !state.error && state.nextOffset !== null && state.loadedPages < pages) {
          expected++;
          await load(true);
        }
      },
      snapshot: function () { return { query: query(state.query), loadedPages: state.loadedPages }; },
      dispose: function () { disposed = true; generation++; state.products = []; state.query = query(); state.error = null; state.loading = false; state.revision = null; }
    };
  }
  return { create: create, query: query };
});
